import React from 'react'

const FormButton = ({id,Buttontext,onClick,className,ButtonIcon,style,disabled}) => {
  return (
    <button id={id} style={style} onClick={onClick} type='submit' className={`${className} ${disabled?'disabled-btn':'enabled-btn '}`} disabled={disabled} >{Buttontext}<span className='ps-2'>{ButtonIcon}</span></button>
  )
}

export default FormButton